import { render, staticRenderFns } from "./ReceiptKTK.vue?vue&type=template&id=118942d2&"
import script from "./ReceiptKTK.vue?vue&type=script&lang=js&"
export * from "./ReceiptKTK.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptKTK.vue?vue&type=style&index=0&id=118942d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports